// extracted by mini-css-extract-plugin
export var askAiIcon = "_pk-9";
export var container = "_pk-0";
export var groupSeparator = "_pk-a";
export var highlight = "_pk-4";
export var resultIcon = "_pk-5";
export var resultItem = "_pk-7";
export var resultSubtitle = "_pk-3";
export var resultTitle = "_pk-2";
export var resultsList = "_pk-1";
export var searchGroup = "_pk-6";
export var selected = "_pk-8";